// export const baseUrl = 'https://stain-cats-eye.sadeem-lab.com/api/v1'
export const baseUrl = 'https://stain-cats-eye.sadeem-factory.com/api/v1'
